/* eslint-disable import/no-absolute-path */
/* eslint-disable react/prop-types */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-undef */
import { PureComponent } from 'react';

import BrandsSlider from './BrandsSlider';

import './BrandSlider.style';

/**
 * Homepage BrandSlider
 * @class BrandSlider
 * @namespace Mspwa/Component/BrandSlider/Component/BrandSliderComponent */
export class BrandSliderComponent extends PureComponent {
    render() {
        const {
            brands: { brands = [] }
        } = this.props;

        return (
            <div className="BrandContainer">
                <BrandsSlider brands={ brands } />
            </div>
        );
    }
}

export default BrandSliderComponent;
